import modal from './modal';

let COUPON = {};

COUPON.init = () => {
  /* Start Coupon add logic*/
  const addNewCouponForm = $('#newCouponCode');
  const submitCouponBtn = $('.js-enter__coupon');
  const messages = window?.cartMessages;
  const inputField = $('#newCouponCode #couponCode');
  if (messages !== '[]') {
    messages?.forEach((message) => {
      if (message.placements.includes('INLINE_COUPON')) {
        addNewCouponForm.fadeIn();
        submitCouponBtn.fadeOut();
        inputField[0].classList.add('error');
        inputField.val(message.messageParams[0]);
      }
    });
  }
  inputField.change(function () {
    inputField[0].classList.remove('error');
  });

  submitCouponBtn.click(function () {
    $(this).css('display', 'none');
    addNewCouponForm.fadeIn();
  });

  $('#removeCouponCode, #newCouponCode').submit(function () {
    localStorage.setItem('scrollToCoupon', true);
  });

  // If the user did an action related with coupons, scroll
  if (localStorage.getItem('scrollToCoupon') !== null) {
    localStorage.removeItem('scrollToCoupon');
    const elementToScroll = $('.coupon_section');
    if (elementToScroll && elementToScroll.length > 0)
      $('html,body').animate(
        { scrollTop: elementToScroll.offset().top },
        'slow',
        'swing'
      );
  }
  /* End Coupon add logic*/
};

export const initCouponModal = () => {
  const couponSeeMoreButton = $('.js-coupon-see-more');
  couponSeeMoreButton.click(function () {
    let $modal = $('.js-coupon-products-modal');

    if ($modal.length) {
      const modalContent = $modal.find('.js-modal__content');
      const messageContent = $(this).data('messageContent');

      modalContent.html(messageContent);

      modal.openModal($modal);
    }
  });
};

export default COUPON;
